// extracted by mini-css-extract-plugin
export default {"main":"ProductFresh_main__KkPYP"};